import { ZopPageConfig } from '@zopup/zop-ux-core';

export const UserProfilePageConfig: ZopPageConfig = {
    title: 'User Profile',
    icon: 'heroicons_outline:user',
    isSidebarOpened: true,
    showBackButton: false,
    showToggleButton: false,
    sidebarWidth: '400',
    sidebarMode: 'side',
    sidebarPosition: 'end',
    hideToolbar: false,
    headerItems: [
        {
            id: 'btn-change-package',
            title: 'Upgrade Package',
            type: 'primary',
            position: 'header',
            active: false,
            hidden: false,
            disabled: false,
            tooltip: 'Upgrade or downgrade your current package.',
            icon: 'mat_solid:credit_card',
            sortOrder: 1,
        },
        {
            id: 'btn-complete-verification',
            title: 'Complete KYC',
            type: 'button',
            position: 'header',
            active: false,
            hidden: false,
            disabled: false,
            tooltip: 'Complete your KYC verification.',
            icon: 'mat_outline:fact_check',
            sortOrder: 2,
        },
        {
            id: 'menu-edit-tenant-details',
            title: 'Edit Account Details',
            type: 'menu-item',
            position: 'header',
            active: false,
            hidden: false,
            disabled: false,
            tooltip: 'Edit your account details.',
            icon: 'mat_solid:account_circle',
            sortOrder: 1,
        },
        {
            id: 'menu-payment-history',
            title: 'Payment History',
            type: 'menu-item',
            position: 'header',
            active: false,
            hidden: false,
            disabled: false,
            tooltip: 'View your Payment History.',
            icon: 'mat_solid:money',
            sortOrder: 2,
        },
        {
            id: 'menu-cancel-subscription',
            title: 'Cancel Subscription',
            type: 'menu-item',
            position: 'header',
            active: false,
            hidden: false,
            disabled: false,
            tooltip: 'Cancel your current subscription.',
            icon: 'mat_solid:credit_card',
            sortOrder: 3,
        },
    ],
    toolbarItems: [],
};
